import angular from "angular";

angular
    .module('ui-sentinel.login', [
        'ui.router',
        'api-sentinel'
    ]);
